import client from './client';

export const listAppVersions = (params) => client.get('/app-versions', { params });

export const createAppVersion = ({
  versionCode,
  versionName,
  releaseNotes,
  forceUpdate,
  published,
  file,
}) => {
  const formData = new FormData();
  formData.append('versionCode', String(versionCode));
  formData.append('versionName', versionName);
  formData.append('releaseNotes', releaseNotes || '');
  formData.append('forceUpdate', String(Boolean(forceUpdate)));
  formData.append('published', String(Boolean(published)));
  formData.append('file', file);

  return client.post('/app-versions', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout: 120000,
  });
};

export const publishAppVersion = (versionId) => client.patch(`/app-versions/${versionId}/publish`);

export const unpublishAppVersion = (versionId) => client.patch(`/app-versions/${versionId}/unpublish`);
